export const colors = {
  warning: '#FFC340',
  info: '#4DB9E1',
  error: '#EB425E',
  success: '#14904A',
  default: '#A8AAAD'
};
